<script>
import speakerDetail from './speaker-detail.vue'
import channelPrivateButton from '../channel/channel-private-button.vue'

export default {
  components: { speakerDetail, channelPrivateButton },
  props: {
    contactId: {type: String, required: true},
  },

  data() {
    return {
      contact: {},
    }
  },

  created() {
    this.fetchContact()
  },
  methods: {
    contactDisplay(contact) {
      return `${contact.first_name} ${contact.last_name}`.trim() || contact.username
    },

    fetchContact() {
      let me = this
      this.$api.get(`/community-users/${this.contactId}/`, ).then(function(response){
        me.contact = response.data
      })
    }
  }
}

</script>

<template>

  <span v-if="contact.speaker">
    <speaker-detail v-if="contact.speaker" :speakerId="contact.speaker.id.toString()" :descriptionOnly="true" />
  </span>
  <span v-else>
    <div class="card mb-2 p-2">
      <img :src="contact.profile_image" class="avatar mx-auto" />
      <div class="card-body text-center">
        <h4 class="card-title mb-0">{{contactDisplay(contact)}}</h4>
        <div class="text-muted"><small>({{contact.username}})</small></div>
        <p v-if="contact.job_title" class="text-muted">
          <small>{{contact.job_title}}</small>
        </p>
        <p>{{contact.company_name}}</p>
        <div class="mb-3">
          <channel-private-button v-if="contact.mmid" :contactId="contact.mmid" ></channel-private-button>
        </div>
      </div>
    </div>
  </span>

</template>

<style scoped>

a { text-decoration:none}

.avatar {
  height:100px;
  width:100px;
  object-fit:cover;
  border-radius:50%;
  overflow:hidden;
}

</style>